import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { LayoutCellNode } from './../../ricos-types';

export const cellConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.LAYOUT_CELL],
    // @ts-expect-error $TSFixMe
    convert: (node: LayoutCellNode, visit: (node: LayoutCellNode) => PmNodeJson[]) => {
      return {
        type: Node_Type.LAYOUT_CELL,
        attrs: {
          colSpan: node.layoutCellData.colSpan,
          id: node.id,
        },
        content: visit(node),
      };
    },
  },
  fromPm: {
    types: [Node_Type.LAYOUT_CELL],
    // @ts-expect-error $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => LayoutCellNode[]) => {
      const { attrs = {} } = node;
      const { id, colSpan } = attrs;
      return {
        type: Node_Type.LAYOUT_CELL,
        id,
        nodes: visit(node),
        layoutCellData: {
          colSpan,
        },
      };
    },
  },
};
